import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { recoverDeletedAccountSubscription } from "../lib/iap";
import { isNative } from "../lib/native";

export default function SubscriptionRecovery() {
  const { refreshUser, billingBusy, runBillingAction } = useAuth();
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  return <section className="hm-card p-5 mt-4">
    <h2 className="font-bold">Abonnement d’un compte supprimé</h2>
    <p className="text-sm mt-2">Utilise le code conservé avant suppression et le même compte Apple ou Google Play. Le code ne peut servir qu’à un seul nouveau compte HitMax.</p>
    {isNative() ? <>
      <label className="block mt-3">Code de récupération<input autoComplete="off" value={code} onChange={(e) => setCode(e.target.value)}
        className="block bg-black border rounded p-2 w-full" /></label>
      <button disabled={busy || billingBusy || code.trim().length < 32} className="underline mt-3" onClick={async () => {
        setBusy(true); setMessage("");
        try {
          const count = await runBillingAction(async () => {
            const n = await recoverDeletedAccountSubscription(code.trim());
            await refreshUser(); return n;
          });
          setCode(""); setMessage(count ? "Abonnement récupéré et droits actualisés." : "Aucun abonnement actif confirmé.");
        } catch (e) { setMessage(e?.response?.data?.detail || e.message || "Récupération impossible"); }
        finally { setBusy(false); }
      }}>Récupérer mon abonnement</button>
    </> : <p className="text-sm mt-2">Ouvre l’application HitMax sur iOS ou Android pour vérifier ton achat auprès de sa boutique.</p>}
    <p className="text-xs mt-3">Code perdu ou ancien compte déjà supprimé sans code : contacte le support via « Demande de récupération » sur la page de suppression du compte. Une preuve d’achat et une vérification du propriétaire seront nécessaires.</p>
    <a href="/supprimer-compte" className="underline text-xs">Suppression et assistance</a>
    {message && <p role="status" className="text-sm mt-2">{message}</p>}
  </section>;
}
